import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Espèces',
    [PaymentMethodsEnum.Online]: 'En ligne',
    [PaymentMethodsEnum.InStoreCard]: 'Carte en magasin',
  },
};
